module.exports = __webpack_public_path__ + "img/(per 1000 live births).70d7e1b2.png";